module.exports = __webpack_public_path__ + "static/wpf-cc1a7dfa695ad1fc0b5841be99275dac.png";